import Vue from 'vue'
import App from './App.vue'
import conf from './config'
import '../theme/index.css'

import i18n from './i18n'

//兼容ie
import 'babel-polyfill'

//引入图标
import './assets/icon/iconfont.css'

// 引入路由
import router from "./routes.js";

//引入vuex
import store from "./store";

/*页面标题插件*/
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);

//全局挂载api
import api from './api/account';
Vue.prototype.$api = api;

//全局挂载js-cookie
import Cookies from 'js-cookie';
Vue.prototype.$Cookies = Cookies;

//全局配置
Vue.prototype.$conf = conf;

//全局挂载消息派发
var eventHub = Vue.prototype.$eventHub || new Vue();
Vue.prototype.$eventHub = eventHub;
import evekey from './communal/eventHub/IEventHub';
Vue.prototype.$evekey = evekey;

//获取当前页面链接？后面的参数
var getUrlPara = function(str) {
    var LocString = String(window.document.location.href);
    var rs = new RegExp("(^|)" + str + "=([^&]*)(&|$)", "gi").exec(LocString),
        tmp;
    if (tmp = rs) return tmp[2];
    return false;
}
Vue.prototype.$getUrlPara = getUrlPara;

//引入进度条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
NProgress.start();


//挂载一次性数据
/*
存put(k,v)
取take(k)
*/
import flashcache from './communal/flashcache/index'
Vue.prototype.$flashcache = flashcache;

/******element-ui全局组件*******/
import { Message, MessageBox, Input, Button, Table, TableColumn, Col, Row,Loading } from 'element-ui'

Vue.use(Input);

Vue.use(Button);

Vue.use(Table);

Vue.use(TableColumn);

Vue.use(Col);

Vue.use(Row);

Vue.use(Loading);

// 全局注入提示
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$alert = MessageBox.alert;
// 全局注入弹框
Vue.prototype.$MessageBox = MessageBox;

/******挂载全局方法*******/
import comm from './communal/index'
import * as dd from 'dingtalk-jsapi';
Vue.prototype.$dd = dd;
Vue.prototype.$comm = comm;
Vue.prototype.$comm['conf'] = conf;

// //扩展数组原型链
// Array.prototype.remove=function(obj){
//     for(var i =0;i <this.length;i++){
//         var temp = this[i];
//         if(!isNaN(obj)){
//             temp=i;
//         }
//         if(temp == obj){
//             for(var j = i;j <this.length;j++){
//                 this[j]=this[j+1];
//             }
//             this.length = this.length-1;
//         }
//     }
// }
Vue.filter('global-filter', (val) => {


    if (val.length > 40) {
        var msg = val.substring(0, val.lastIndexOf('.'));
        var index = val.lastIndexOf("\.");
        var type = val.substring(index + 1, val.length);
        msg = msg.substring(0, msg.length - 36);
        console.log(msg + '.' + type);

        return msg + '.' + type
    } else {
        return val
    }

})

//当路由进入前
router.beforeEach((to, from, next) => {

    let simple_path = to.path.split('?')[0];

    //没有公司
    if (store.getters.isExistCompany === 1 && simple_path != '/user/user_center' && simple_path != '/login') {
        NProgress.done();
        Message({
            message: '当前用户没有所属企业，请先加入企业后，再操作',
            type: 'warning'
        });
        return;
    }

    //储存当前路由
    store.state.app.aftPath = simple_path;

    // 每次切换页面时，调用进度条
    NProgress.start();

    //判断登录状态
    var token = store.getters.token;

    // 是否有vuex的缓存
    if (token == '' && sessionStorage.getItem("app_store")) {

        conf.dbug ? console.warn('读取vuex缓存') : '';

        store.state.app = JSON.parse(sessionStorage.getItem("app_store"));

    }

    //判断登录状态
    var token = store.getters.token ;
    // var token = store.getters.token || Cookies.get('u8d_oasite_token');

    // if (conf.no_c_url.indexOf(simple_path) === -1 && token == '') {

    //     // Message({
    //     //     message: '未登录或登录失效，请重新登录。',
    //     //     type: 'warning'
    //     // });
    //     //alert("未登录")
    //     //router.push({ path: '/authcode' })
    //      router.push({ path: '/login' })
    //     return;

    // }

    //是否需要更新首页数据
    if (simple_path === '/index') {
        eventHub.$emit(evekey['UPDATE_INDEX']);
        store.dispatch('setIndexNavAftFun', '/index');
    }

    next(); // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了

});

//当路由进入后：关闭进度条
router.afterEach((to, from) => {

    let simple_path = to.fullPath.split('?')[0];

    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()

    //设置背景颜色
    if (conf.need_page.indexOf(simple_path) === -1) {
        window.document.body.style.backgroundColor = '#f2f2f3';
    } else {
        window.document.body.style.backgroundColor = '#fff';
    }

    //改变主路由选中状态
    var main_routes = [
        '/department',
        '/businessdata',
        '/Enterprises_nav/Enterprises_message',

    ]
    if (main_routes.indexOf(simple_path) !== -1) {
        store.dispatch('setNavstateFun', simple_path);
    }

    //设置当前路由
    store.dispatch('setIndexNavAftFun', simple_path);

    //清空控制台
    conf.dbug ? '' : console.clear();
    console.log("process.env.HOST:", process.env.HOST)

});

//日期扩展函数
Date.prototype.format = function(fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

//初始化
new Vue({
    el: '#app',
    router, // 注入到根实例中
    store,
    i18n,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js